export class FetchError extends Error {
  readonly statusCode: number;

  constructor(statusCode: number, message: string) {
    super(message);
    this.statusCode = statusCode;
    this.name = "FetchError";
    // Maintain proper stack trace
    Object.setPrototypeOf(this, FetchError.prototype);
  }

  toJSON() {
    return {
      statusCode: this.statusCode,
      message: this.message,
    };
  }

  // Static method to recreate object from JSON
  static fromJSON(json: string) {
    const obj = JSON.parse(json);
    return new FetchError(obj.statusCode, obj.message);
  }
}
